// src/components/ai/WelcomeScreen.js
import { useState } from 'react';
import { BsSend, BsStars } from 'react-icons/bs';

export default function WelcomeScreen({ onSend }) {
  const [query, setQuery] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (query.trim()) onSend(query);
  };

  return (
    <div className="flex flex-col items-center justify-center h-full px-4 text-center">
      {/* انیمیشن اسپارک */}
      <div className="mb-6 relative">
        <BsStars className="text-5xl text-blue-500 animate-pulse" />
        <div className="absolute -top-2 -left-2 w-6 h-6 bg-blue-300 rounded-full opacity-75 animate-ping" />
      </div>

      <h1 className="text-2xl font-bold text-gray-800 mb-2">دستیار هوشمند فرزانه</h1>
      <p className="text-xs text-gray-500 max-w-md mb-8 leading-relaxed">
        من دستیار هوشمند «فرزانه» هستم، طراحی شده‌ام تا شما را در درک عمیق‌تر دیدگاه‌ها و آثار استاد مصطفی ملکیان همراهی کنم.
      </p>

      {/* Input ارسال */}
      <div className="w-full max-w-lg relative">
        <textarea
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSubmit();
            }
          }}
          placeholder="پرسش خود را بنویسید..."
          rows={2}
          className="w-full min-h-[56px] px-5 py-4 bg-white/40 backdrop-blur-md border border-gray-300/60 rounded-2xl outline-none transition-all text-sm resize-none text-gray-800 placeholder:text-gray-500 shadow-lg"
        />
        <button
          onClick={handleSubmit}
          disabled={!query.trim()}
          className={`absolute bottom-5 left-3 h-10 w-10 rounded-xl flex items-center justify-center transition-all duration-200 ${
            query.trim()
              ? 'bg-violet-600 hover:bg-purple-700 text-white shadow-md shadow-purple-200 active:scale-95'
              : 'bg-gray-200 text-gray-400 cursor-not-allowed'
          }`}
        >
          <BsSend size={16} />
        </button>
      </div>
    </div>
  );
}